// app/components/NavbarClientOnly.tsx
'use client';

import { useEffect, useState } from 'react';
import Navbar from '@/app/components/Navbar';

export default function NavbarClientOnly() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return <Navbar />;
}
